// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Trick or Treat (seasonalBranding === 'halloween') styles for the random game picker:
 * \`.theme\` sets the --rgm-* colour variables read by RandomGameModal.module.css, the rest
 * styles the DoorReveal doors.
 */
.VLkgxQxXGeEPwzBGflBH {
  --rgm-modal-bg: rgba(28, 20, 36, 0.94);
  --rgm-modal-border: #4a3560;
  --rgm-modal-shadow: 0 0 24px rgba(255, 122, 26, 0.18), 0 0 8px #000000cc;
  --rgm-title-color: #ffb35c;
  --rgm-title-shadow: 0 0 14px rgba(255, 138, 31, 0.5);
  /* Two lines (2 × 22px), so a longer translation wrapping can't resize the modal on "Knock again". */
  --rgm-subtitle-min-height: 44px;
  --rgm-placeholder-bg: linear-gradient(135deg, #2a1d3b 0%, #15101c 100%);
  /* Transparent so it doesn't peek out from behind the doors during the knock shake. */
  --rgm-placeholder-border: transparent;
  --rgm-question-color: #ffb35c;
  --rgm-play-bg: #ff8a1f;
  --rgm-play-color: #1a0d00;
  --rgm-again-bg: #2a1d3b;
  --rgm-again-border: rgba(255, 138, 31, 0.5);
  --rgm-again-color: #ffb35c;
}
/* ── Door reveal (DoorReveal.tsx) ─────────────────────────────────────────────────────── */
/* The frame adds nothing to the sizing chain: it is a flex wrapper that mirrors .gameCardContainer
   (RandomGameModal.module.css), so the card is laid out by exactly the same rules as in the plain
   reveal, and the doors are absolutely inset over whatever box the card ends up with. Giving the
   frame its own grid track / aspect-ratio made it size independently of the flex-shrunk container
   in short landscape viewports and the card overflowed toward the buttons (ON-170100, ON-170097). */
.xC688AR5X1_O8zsE418O {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  max-height: 100%;
  perspective: 900px;
}
/* 1px larger than the card on every side: with coincident edges/radii the card's edge
   antialiases through the doors as a bright fringe (seen at fractional x on desktop). */
.Ew2lZFU8rRJa99FfxpHL {
  position: absolute;
  inset: -1px;
  pointer-events: none;
}
.xC688AR5X1_O8zsE418O[data-state='closed'] .Ew2lZFU8rRJa99FfxpHL {
  animation: CnmYZEveARuZTBrCewjx 0.45s ease-in-out 2;
}
.Wu53VUoxkoTGtRcfIuDJ {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 50.5%;
  background: linear-gradient(90deg, #3b2314, #5a341c 45%, #3b2314);
  border: 1px solid #1d0f08;
  box-shadow: inset 0 0 24px rgba(0, 0, 0, 0.55);
  backface-visibility: hidden;
  /* Shutting (Knock again) snaps back at once; opening fades late, see the open rule. */
  transition: transform 0.8s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.15s ease;
}
/* Panel inset */
.Wu53VUoxkoTGtRcfIuDJ::before {
  content: '';
  position: absolute;
  inset: 10px 8px;
  border: 1px solid rgba(0, 0, 0, 0.35);
  border-radius: 4px;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.04);
}
/* Knob */
.Wu53VUoxkoTGtRcfIuDJ::after {
  content: '';
  position: absolute;
  top: 50%;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: radial-gradient(circle at 35% 35%, #ffd27a, #b8641a);
  box-shadow: 0 0 6px rgba(255, 138, 31, 0.7);
  transform: translateY(-50%);
}
.ZyTZ86M5I_IMeGRSEoG5 {
  left: 0;
  border-radius: var(--border-radius-for-game-cards, 5px) 0 0 var(--border-radius-for-game-cards, 5px);
  transform-origin: left center;
}
.ZyTZ86M5I_IMeGRSEoG5::after {
  right: 8px;
}
.xI45q3WQ9JqJ8_rjj7Fs {
  right: 0;
  border-radius: 0 var(--border-radius-for-game-cards, 5px) var(--border-radius-for-game-cards, 5px) 0;
  transform-origin: right center;
}
.xI45q3WQ9JqJ8_rjj7Fs::after {
  left: 8px;
}
.xC688AR5X1_O8zsE418O[data-state='open'] .Wu53VUoxkoTGtRcfIuDJ {
  opacity: 0;
  transition: transform 0.8s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.3s ease 0.55s;
}
.xC688AR5X1_O8zsE418O[data-state='open'] .ZyTZ86M5I_IMeGRSEoG5 {
  transform: rotateY(-110deg);
}
.xC688AR5X1_O8zsE418O[data-state='open'] .xI45q3WQ9JqJ8_rjj7Fs {
  transform: rotateY(110deg);
}
@keyframes CnmYZEveARuZTBrCewjx {
  0%,
  100% {
    transform: translateX(0);
  }
  20% {
    transform: translateX(-3px);
  }
  40% {
    transform: translateX(3px);
  }
  60% {
    transform: translateX(-2px);
  }
  80% {
    transform: translateX(2px);
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/search/components/RandomGameModal/brandings/halloween/halloween.module.css"],"names":[],"mappings":"AAAA;;;;EAIE;AACF;EACE,sCAAsC;EACtC,2BAA2B;EAC3B,wEAAwE;EACxE,0BAA0B;EAC1B,oDAAoD;EACpD,oGAAoG;EACpG,+BAA+B;EAC/B,uEAAuE;EACvE,qFAAqF;EACrF,qCAAqC;EACrC,6BAA6B;EAC7B,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;EACvB,2CAA2C;EAC3C,0BAA0B;AAC5B;AACA,4FAA4F;AAC5F;;;;oGAIoG;AACpG;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;AACA;wFACwF;AACxF;EACE,kBAAkB;EAClB,WAAW;EACX,oBAAoB;AACtB;AACA;EACE,mDAAoC;AACtC;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,YAAY;EACZ,iEAAiE;EACjE,yBAAyB;EACzB,8CAA8C;EAC9C,2BAA2B;EAC3B,sFAAsF;EACtF,2EAA2E;AAC7E;AACA,gBAAgB;AAChB;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,qCAAqC;EACrC,kBAAkB;EAClB,qDAAqD;AACvD;AACA,SAAS;AACT;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,gEAAgE;EAChE,2CAA2C;EAC3C,2BAA2B;AAC7B;AACA;EACE,OAAO;EACP,oGAAoG;EACpG,6BAA6B;AAC/B;AACA;EACE,UAAU;AACZ;AACA;EACE,QAAQ;EACR,oGAAoG;EACpG,8BAA8B;AAChC;AACA;EACE,SAAS;AACX;AACA;EACE,UAAU;EACV,gFAAgF;AAClF;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE;;IAEE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/**\n * Trick or Treat (seasonalBranding === 'halloween') styles for the random game picker:\n * `.theme` sets the --rgm-* colour variables read by RandomGameModal.module.css, the rest\n * styles the DoorReveal doors.\n */\n.theme {\n  --rgm-modal-bg: rgba(28, 20, 36, 0.94);\n  --rgm-modal-border: #4a3560;\n  --rgm-modal-shadow: 0 0 24px rgba(255, 122, 26, 0.18), 0 0 8px #000000cc;\n  --rgm-title-color: #ffb35c;\n  --rgm-title-shadow: 0 0 14px rgba(255, 138, 31, 0.5);\n  /* Two lines (2 × 22px), so a longer translation wrapping can't resize the modal on \"Knock again\". */\n  --rgm-subtitle-min-height: 44px;\n  --rgm-placeholder-bg: linear-gradient(135deg, #2a1d3b 0%, #15101c 100%);\n  /* Transparent so it doesn't peek out from behind the doors during the knock shake. */\n  --rgm-placeholder-border: transparent;\n  --rgm-question-color: #ffb35c;\n  --rgm-play-bg: #ff8a1f;\n  --rgm-play-color: #1a0d00;\n  --rgm-again-bg: #2a1d3b;\n  --rgm-again-border: rgba(255, 138, 31, 0.5);\n  --rgm-again-color: #ffb35c;\n}\n/* ── Door reveal (DoorReveal.tsx) ─────────────────────────────────────────────────────── */\n/* The frame adds nothing to the sizing chain: it is a flex wrapper that mirrors .gameCardContainer\n   (RandomGameModal.module.css), so the card is laid out by exactly the same rules as in the plain\n   reveal, and the doors are absolutely inset over whatever box the card ends up with. Giving the\n   frame its own grid track / aspect-ratio made it size independently of the flex-shrunk container\n   in short landscape viewports and the card overflowed toward the buttons (ON-170100, ON-170097). */\n.frame {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  max-height: 100%;\n  perspective: 900px;\n}\n/* 1px larger than the card on every side: with coincident edges/radii the card's edge\n   antialiases through the doors as a bright fringe (seen at fractional x on desktop). */\n.doors {\n  position: absolute;\n  inset: -1px;\n  pointer-events: none;\n}\n.frame[data-state='closed'] .doors {\n  animation: knock 0.45s ease-in-out 2;\n}\n.door {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  width: 50.5%;\n  background: linear-gradient(90deg, #3b2314, #5a341c 45%, #3b2314);\n  border: 1px solid #1d0f08;\n  box-shadow: inset 0 0 24px rgba(0, 0, 0, 0.55);\n  backface-visibility: hidden;\n  /* Shutting (Knock again) snaps back at once; opening fades late, see the open rule. */\n  transition: transform 0.8s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.15s ease;\n}\n/* Panel inset */\n.door::before {\n  content: '';\n  position: absolute;\n  inset: 10px 8px;\n  border: 1px solid rgba(0, 0, 0, 0.35);\n  border-radius: 4px;\n  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.04);\n}\n/* Knob */\n.door::after {\n  content: '';\n  position: absolute;\n  top: 50%;\n  width: 9px;\n  height: 9px;\n  border-radius: 50%;\n  background: radial-gradient(circle at 35% 35%, #ffd27a, #b8641a);\n  box-shadow: 0 0 6px rgba(255, 138, 31, 0.7);\n  transform: translateY(-50%);\n}\n.doorLeft {\n  left: 0;\n  border-radius: var(--border-radius-for-game-cards, 5px) 0 0 var(--border-radius-for-game-cards, 5px);\n  transform-origin: left center;\n}\n.doorLeft::after {\n  right: 8px;\n}\n.doorRight {\n  right: 0;\n  border-radius: 0 var(--border-radius-for-game-cards, 5px) var(--border-radius-for-game-cards, 5px) 0;\n  transform-origin: right center;\n}\n.doorRight::after {\n  left: 8px;\n}\n.frame[data-state='open'] .door {\n  opacity: 0;\n  transition: transform 0.8s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.3s ease 0.55s;\n}\n.frame[data-state='open'] .doorLeft {\n  transform: rotateY(-110deg);\n}\n.frame[data-state='open'] .doorRight {\n  transform: rotateY(110deg);\n}\n@keyframes knock {\n  0%,\n  100% {\n    transform: translateX(0);\n  }\n  20% {\n    transform: translateX(-3px);\n  }\n  40% {\n    transform: translateX(3px);\n  }\n  60% {\n    transform: translateX(-2px);\n  }\n  80% {\n    transform: translateX(2px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"theme": `VLkgxQxXGeEPwzBGflBH`,
	"frame": `xC688AR5X1_O8zsE418O`,
	"doors": `Ew2lZFU8rRJa99FfxpHL`,
	"knock": `CnmYZEveARuZTBrCewjx`,
	"door": `Wu53VUoxkoTGtRcfIuDJ`,
	"doorLeft": `ZyTZ86M5I_IMeGRSEoG5`,
	"doorRight": `xI45q3WQ9JqJ8_rjj7Fs`
};
export default ___CSS_LOADER_EXPORT___;
